import React from "react";
import { motion } from "framer-motion";
import { BRAND } from "@/constants/brand";
import { RecipeCard } from "@/components/RecipeCard";

function renderText(text) {
  // simple formatting: **bold**, line breaks, bullet lines
  const lines = text.split("\n");
  return lines.map((line, i) => {
    const parts = line.split(/(\*\*[^*]+\*\*)/g).map((p, j) =>
      p.startsWith("**") && p.endsWith("**") ? (
        <strong key={j} className="font-semibold text-espresso">{p.slice(2, -2)}</strong>
      ) : (
        <React.Fragment key={j}>{p}</React.Fragment>
      )
    );
    return (
      <span key={i} className="block">
        {parts}
      </span>
    );
  });
}

export function ChatMessage({ role, text, recipe, onStartCooking, onSave, saved, streaming, onAddToList, onShare }) {
  const isUser = role === "user";
  return (
    <motion.div
      initial={{ opacity: 0, y: 18 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.3 }}
      className={`flex w-full gap-3 ${isUser ? "justify-end" : "justify-start"}`}
      data-testid={`chat-message-${role}`}
    >
      {!isUser && (
        <img
          src={BRAND.character}
          alt="Aunt Loretta"
          className="h-10 w-10 shrink-0 rounded-full border-2 border-loretta-accent bg-white object-cover object-top"
        />
      )}
      <div className={`flex max-w-[85%] flex-col sm:max-w-[70%] ${isUser ? "items-end" : "items-start"}`}>
        {text && (
          <div
            className={`rounded-2xl px-4 py-3 text-[15px] leading-relaxed ${
              isUser
                ? "rounded-tr-sm bg-loretta-red text-white"
                : "rounded-tl-sm bg-creamalt text-espresso"
            }`}
          >
            {renderText(text)}
            {streaming && <span className="ml-0.5 inline-block h-4 w-1.5 animate-pulse bg-espresso/40 align-middle" />}
          </div>
        )}
        {recipe && (
          <RecipeCard recipe={recipe} onStartCooking={onStartCooking} onSave={onSave} saved={saved} onAddToList={onAddToList} onShare={onShare} />
        )}
      </div>
    </motion.div>
  );
}
